

/* ============================================================
   SUMMARY BAR
   ============================================================ */

import { Box, Paper, Typography } from "@material-ui/core";
import { formatDateTime } from "./utils";

import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';

interface SummaryBarProps {
  lastScan: Date | null;
  duplicateCount: number;
  recordCount: number;
  createdRangeLabel: string;
}


export const SummaryBar: React.FC<
  SummaryBarProps
> = ({
  lastScan,
  duplicateCount,
  recordCount,
  createdRangeLabel,
}) => {

  return (
    <Box
      style={{
        padding:
          '7px 20px',
        flexShrink: 0,
        background:
          '#FFFFFF',
      }}
    >

      <Paper
        elevation={0}
        style={{
          height: 42,
          padding:
            '0 13px',
          display: 'flex',
          alignItems: 'center',
          border:
            '1px solid #D8E4F6',
          borderRadius: 6,
          background:
            'linear-gradient(90deg, #FFFFFF, #F8FBFF)',
        }}
      >

        <Box
          display="flex"
          alignItems="center"
        >

          <CalendarTodayOutlinedIcon
            style={{
              fontSize: 16,
              color:
                '#2563EB',
              marginRight: 7,
            }}
          />

          <Typography
            style={{
              fontSize: 12,
              color:
                '#64748B',
            }}
          >
            Last scan:
          </Typography>

          <Typography
            style={{
              marginLeft: 5,
              fontSize: 12,
              fontWeight: 600,
              color:
                '#1E293B',
            }}
          >
            {lastScan
              ? formatDateTime(
                  lastScan
                )
              : '—'}
          </Typography>

        </Box>


        <Box
          style={{
            height: 21,
            width: 1,
            margin:
              '0 28px',
            background:
              '#DCE3ED',
          }}
        />


        <Box
          display="flex"
          alignItems="center"
        >

          <WarningOutlinedIcon
            style={{
              fontSize: 18,
              color:
                '#F59E0B',
              marginRight: 6,
            }}
          />

          <Typography
            style={{
              fontSize: 12,
              color:
                '#64748B',
            }}
          >
            Potential Duplicates:
          </Typography>

          <Typography
            style={{
              marginLeft: 5,
              fontSize: 15,
              fontWeight: 700,
              color:
                '#DC2626',
            }}
          >
            {duplicateCount}
          </Typography>

        </Box>


        <Box
          style={{
            flex: 1,
          }}
        />


        <Box
          style={{
            textAlign: 'right',
          }}
        >
          <Typography
            style={{
              fontSize: 10,
              color: '#94A3B8',
            }}
          >
            {recordCount}
            {' '}
            records scanned
          </Typography>

          <Typography
            style={{
              marginTop: 2,
              fontSize: 10,
              fontWeight: 600,
              color: '#64748B',
            }}
          >
            {createdRangeLabel}
          </Typography>
        </Box>

      </Paper>

    </Box>
  );
};

